import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.lucky_wheel.sectors,
    props.lucky_wheel.wheel,
    (sectors, wheel) => {
        return {
            sectors,
            wheel
        }
    }
)